import myFavourites from 'html/customize/my-favourites.html';
import App from 'app/app.js';
import 'app/directive/LtMyFavouriteCtrl.js';

function LtMyFavouriteDirective() {
  return {
    restrict: 'E',
    scope: {
      favouriteLooks: '=',
      choosedLook: '=',
      selectedSheetIndex: '=',
      changeLook: '&'
    },
    template: myFavourites,
    controller: 'LtMyFavouriteCtrl',
    controllerAs: 'myFavouriteCtrl'
  };
}

App.directive('ltMyFavourite', [LtMyFavouriteDirective]);
